import React, { Suspense, useContext, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { MainLayout } from '@/components/Layout';
import { lazyImport } from '@/utils/lazyImport';
const { CalendarNew } = lazyImport(
  () => import('@/features/Calendar/components/CalendarNew'),
  'CalendarNew'
);
const { Profile } = lazyImport(() => import('@/features/users'), 'Profile');
const { BusinessInfo } = lazyImport(() => import('@/features/business'), 'BusinessInfo');
const { SetupBusiness } = lazyImport(() => import('@/features/business'), 'SetupBusiness');
const { Events } = lazyImport(() => import('@/features/events'), 'Events');
const { Services } = lazyImport(() => import('@/features/services'), 'Services');
const { AddService } = lazyImport(() => import('@/features/services'), 'AddService');
const { EditService } = lazyImport(() => import('@/features/services'), 'EditService');
const { BusinessHours } = lazyImport(() => import('@/features/business'), 'BusinessHours');
const { Availablity } = lazyImport(() => import('@/features/availability'), 'Availablity');
const { ShareLink } = lazyImport(() => import('@/features/sharelink'), 'ShareLink');
const { Payment } = lazyImport(() => import('@/features/payment'), 'Payment');
const { Billing } = lazyImport(() => import('@/features/billing'), 'Billing');
const { PaypalConnect } = lazyImport(() => import('@/features/payment'), 'PaypalConnect');
const { Payouts } = lazyImport(() => import('@/features/payouts'), 'Payouts');
const { BusinessList } = lazyImport(() => import('@/features/businesses'), 'BusinessList');
const { HolidaysList } = lazyImport(() => import('@/features/holiday'), 'HolidaysList');
const { LocationsUsers } = lazyImport(() => import('@/features/location'), 'LocationsUsers');
const { NewLocation } = lazyImport(() => import('@/features/business'), 'NewLocation');
const { Reviews } = lazyImport(() => import('@/features/reviews'), 'Reviews');
const { PetAttributes } = lazyImport(() => import('@/features/petAttributes'), 'PetAttributes');
const { Communication } = lazyImport(() => import('@/features/communication'), 'Communication');
const { CustomerList } = lazyImport(() => import('@/features/customers'), 'CustomerList');
const { CustomerDetails } = lazyImport(() => import('@/features/customers'), 'CustomerDetails');
const { RoomsList } = lazyImport(() => import('@/features/rooms'), 'RoomsList');
const { Promotions } = lazyImport(() => import('@/features/promotions'), 'Promotions');
const { ChatAssistant } = lazyImport(() => import('@/features/bot'), 'ChatAssistant');

const { Maps } = lazyImport(() => import('@/features/maps'), 'Maps');
const { Reports } = lazyImport(() => import('@/features/reports'), 'Reports');

const { BusinessLocationList } = lazyImport(
  () => import('@/features/businesses'),
  'BusinessLocationList'
);
import appCompoLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import { useBuisiness } from '@/features/business/api/getBisiness';

import { SUPER_ADMIN_ROLE } from '@/config';
import { useAuth } from '@/lib/auth';
import { LocationList } from '@/features/location/routes/LocationList';
import { PrefillLocationInfo } from '@/features/location/routes/PrefillLocationInfo';
import { MobileAppConfiguration } from '@/features/businesses/routes/appConfiguration';
import { QBTransactions } from '@/features/qb';
import { Subscriptions } from '@/features/subscriptions/routes/Subscriptions';
import PetDetails from '@/features/customers/components/MyPetProfile';
import QbCallback from '@/features/qb/routes/qbCallback';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import '../i18next.ts';

import { CreateIntakeForm } from '@/features/intakeform';
import { UserContext } from '.';
import { IntakeForm } from '@/features/intakeform/routes/intakeForm';
import { ServiceTips } from '@/features/Calendar/components/ServiceTips';
import { ChatAssistantV1 } from '@/features/bot/routes/ChatAssistantV1';

const App = () => {
  const userContext = useContext(UserContext);
  const [showCongratsDilaog, setShowCongratsDialog] = useState(false);
  const { user } = useAuth();
  const businessQuery = useBuisiness({ businessId: user?.businessId });

  // useEffect(() => {
  //   if (businessQuery?.data?.country) {
  //     const language = businessQuery?.data?.country === 'New Zealand' ? 'en-NZ' : 'en-US';
  //     i18n.changeLanguage(language).then(() => {
  //       //console.log(`Language changed to: ${i18n.language}`);
  //     });
  //   }
  // }, [businessQuery?.data?.country]);

  useEffect(() => {
    if (businessQuery.data && businessQuery.data.id) {
      setShowCongratsDialog(!businessQuery.data.isSetup);
      userContext?.setBussiness(businessQuery.data);
    }
  }, [businessQuery.data]);
  if (!businessQuery.data || businessQuery.isLoading) {
    return <div></div>;
  }
  if (window.location.pathname.indexOf('qb/callback') >= 0) {
    return (
      <div className="home-page">
        <Routes>
          <Route path="/qb/callback" element={<QbCallback />} />
        </Routes>
      </div>
    );
  }
  if (user?.businessUserRole?.name != SUPER_ADMIN_ROLE && showCongratsDilaog) {
    return (
      <div className="home-page">
        <Routes>
          <Route path="/*" element={<SetupBusiness />} />
        </Routes>
      </div>
    );
  }
  const subscriptionDetails = user?.subscriptionDetails;
  return (
    <I18nextProvider i18n={i18n}>
      <MainLayout>
        <Suspense
          fallback={
            <div className="h-full w-full flex items-center justify-center">
              <Lottie className="hw-60" animationData={appCompoLoading} />
            </div>
          }
        >
          {user?.businessUserRole?.name == SUPER_ADMIN_ROLE ? (
            <Routes>
              {/* <Route path="/payout" element={<Payouts />} /> */}
              <Route path="/calender" element={<CalendarNew />} />
              <Route path="/businesses" element={<BusinessList />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/mobileapp" element={<MobileAppConfiguration />} />
              <Route path="/business-locations" element={<BusinessLocationList />} />
              <Route path="/locations" element={<LocationList />} />
              <Route path="/add-location" element={<PrefillLocationInfo />} />
              <Route path="/services/:locationId" element={<Services />} />
              <Route path="/add-service/:locationId" element={<AddService />} />
              <Route path="/edit-service/:locationId/:serviceId" element={<EditService />} />
              <Route path="/" element={<BusinessList />} />
            </Routes>
          ) : (subscriptionDetails && subscriptionDetails?.status === 'trialing') ||
            subscriptionDetails?.status === 'active' ||
            subscriptionDetails?.status === 'past_due' ? (
            <Routes>
              <Route path="/" element={<Availablity />} />
              <Route path="/events" element={<Events />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/services" element={<Services />} />
              <Route path="/add-service" element={<AddService />} />
              <Route path="/edit-service" element={<EditService />} />
              <Route path="/businessinfo" element={<BusinessInfo />} />
              <Route path="/business-hours" element={<BusinessHours />} />
              <Route path="/business-hours/:locationID" element={<BusinessHours />} />
              <Route path="/availability" element={<Availablity />} />
              <Route path="/availability/:petParentId" element={<Availablity />} />
              <Route path="/calender" element={<CalendarNew />} />
              <Route path="/member/:id/tips/" element={<ServiceTips />} />

              <Route path="/sharelink" element={<ShareLink />} />
              <Route path="/settings" element={<Payment />} />
              <Route path="/paypal" element={<PaypalConnect />} />
              <Route path="/holidays" element={<HolidaysList />} />
              <Route path="/locations" element={<LocationsUsers />} />
              <Route path="/new-location" element={<NewLocation />} />
              <Route path="/new-location/:locationID" element={<NewLocation />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/communication" element={<Communication />} />
              <Route path="/pet-attribute" element={<PetAttributes />} />
              <Route path="/customers" element={<CustomerList />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/customer-details/:phone" element={<CustomerDetails />} />
              <Route path="/customer-details/:phone/pet-profiles/:id" element={<PetDetails />} />
              <Route path="/maps" element={<Maps />} />
              <Route path="/rooms" element={<RoomsList />} />
              <Route path="/intake-form" element={<CreateIntakeForm />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/emily-assistant" element={<ChatAssistantV1 />} />

              {user?.activeLocation?.qbAuthorized && (
                <Route path="/quickbook-transactions" element={<QBTransactions />} />
              )}
              <Route
                path="/customer-details/:phone/intake-form/:readOnly/:formId/:responseId"
                element={<IntakeForm />}
              />
              {user?.activeLocation?.qbAuthorized && (
                <Route path="/quickbook-transactions" element={<QBTransactions />} />
              )}
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<Billing />} />
              <Route path="/billing" element={<Billing />} />
            </Routes>
          )}
        </Suspense>
      </MainLayout>
    </I18nextProvider>
  );
};
export const protectedRoutes = [
  {
    path: '/*',
    element: <App />,
  },
];
